import Vue from 'vue'
import Vuex from 'vuex'
import * as ACTIONS from '../actions'
import * as MUTATIONS from '../mutations'
import API from '../../services/api'

Vue.use(Vuex)

export default {
	state: {
		type: 1,
		list: [],
		followers: [],
		engagements: [],
		influencers: 0,
		business: 0,
		current: null,
	},
	mutations: {
		[MUTATIONS.ACCOUNT.TYPE_COUNT](state, type_count) {
			state.business = type_count.business
			state.influencers = type_count.influencers
		},
		[MUTATIONS.ACCOUNT.CHANGE_TYPE](state, type) {
			state.type = type
		},
		[MUTATIONS.ACCOUNT.LIST](state, list) {
			state.list = list
		},
		[MUTATIONS.ACCOUNT.UPDATE](state, account) {
			let result = state.list.find(d => {
				return d.id === account.id
			})

			const idx = state.list.indexOf(result)
			if (idx > -1) {
				let old = state.list[idx]

				for (var prop in account) {
					if (Object.prototype.hasOwnProperty.call(account, prop)) {
						old[prop] = account[prop]
					}
				}

				Vue.set(state.list, idx, old)
			}
		},

		[MUTATIONS.ACCOUNT.TOP_FOLLOWERS](state, list) {
			state.followers = list
		},
		[MUTATIONS.ACCOUNT.TOP_ENGAGEMENT](state, list) {
			state.engagements = list
		},
		[MUTATIONS.ACCOUNT.CREATE](state, account) {
			let list = [...state.list].concat(account)
			state.list = list
		},
		[MUTATIONS.ACCOUNT.DELETE](state, account) {
			state.list.splice(state.list.indexOf(account), 1)
		},
		[MUTATIONS.ACCOUNT.CURRENT](state, account) {
			state.current = account
		},

		[MUTATIONS.ACCOUNT.REMOVE_GROUP](state, group) {
			for (const account of state.list) {
				if (account.groupId === group.id) {
					account.groupId = 'null'
				}
			}
		},
	},
	actions: {
		[ACTIONS.ACCOUNT.TYPE_COUNT]({ commit, dispatch, state }) {
			return API.ACCOUNT.TYPE_COUNT().then(res => {
				commit(MUTATIONS.ACCOUNT.TYPE_COUNT, res)
				return res
			})
		},
		[ACTIONS.ACCOUNT.DELETE]({ commit, dispatch, state }, account) {
			return API.ACCOUNT.DELETE(
				account.influencer.id,
				account.influencer.groupId,
			).then(res => {
				commit(MUTATIONS.ACCOUNT.DELETE, account)
				return res
			})
		},
		[ACTIONS.ACCOUNT.TOP_FOLLOWERS]({ commit, dispatch, state }, filter = {}) {
			return API.ACCOUNT.LIST(filter).then(res => {
				commit(MUTATIONS.ACCOUNT.TOP_FOLLOWERS, res)
				return res
			})
		},
		[ACTIONS.ACCOUNT.TOP_ENGAGEMENT]({ commit, dispatch, state }, filter = {}) {
			return API.ACCOUNT.ENGAGEMENT_LIST(filter).then(res => {
				commit(MUTATIONS.ACCOUNT.TOP_ENGAGEMENT, res)
				return res
			})
		},

		[ACTIONS.ACCOUNT.LIST]({ commit, dispatch, state }, filter = {}) {
			return API.ACCOUNT.LIST(filter).then(res => {
				commit(MUTATIONS.ACCOUNT.LIST, res)
				return res
			})
		},
		[ACTIONS.ACCOUNT.BY_ID]({ commit, dispatch, state }, { id }) {
			return API.ACCOUNT.BY_ID(id).then(res => {
				commit(MUTATIONS.ACCOUNT.CURRENT, res)
			})
		},
		[ACTIONS.ACCOUNT.CREATE]({ commit, dispatch, state }, { name, typeId }) {
			return API.ACCOUNT.CREATE({ name, typeId }).then(res => {
				commit(MUTATIONS.ACCOUNT.CREATE, res)
			})
		},
		[ACTIONS.ACCOUNT.UPDATE]({ commit, dispatch, state }, account) {
			return API.ACCOUNT.UPDATE(account).then(res => {
				commit(MUTATIONS.ACCOUNT.UPDATE, account)
			})
		},
		[ACTIONS.ACCOUNT.SEARCH]({ commit, dispatch, state }, { name = '' }) {
			let filtered = state.list.filter(account => {
				return account.name.toLowerCase().includes(name.toLowerCase())
			})

			return filtered
		},
	},

	getters: {
		getAccountInfluencers: state => state.influencers,
		getAccountBusiness: state => state.business,
		getAccountTopFollowers: state => state.followers,
		getAccountTopEngagements: state => state.engagements,
		getAccountList: state => {
			return state.list.filter(account => {
				return account.typeId === state.type
			})
		},
		getCurrentAccount: state => state.current,
	},
}
